export { default as VuetifyPlugin } from "./vuetify";
